import React from 'react';
import { styled } from '@glitz/react';
import FacetValueViewModel from 'Shared/Facet/FacetValueViewModel.type';
import FacetViewModel from 'Shared/Facet/FacetViewModel.type';
import * as style from 'Shared/Style';

type PropType = { 
  facet: FacetViewModel;
  onFilterValuesUpdated: (filterValues: FacetValueViewModel[], ticket: string) => void;
};

const ToggleLabel = styled.label({
  position: 'relative',
  outlineStyle: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  flexDirection: 'row-reverse',
  cursor: 'pointer',
})

const ToggleInput = styled.input({
  position: 'absolute',
  top: '-99999px',
  left: '-99999px',
})

const ToggleSwitch = styled.div({
  position: 'relative',
  cursor: 'pointer',
  marginRight: '8px',
  height: '16px',
  width: '28px',
  border: {
    xy: {
      width: '1px',
      style: 'solid',
      color: style.colors.monochrome.black,
    },
  },
  borderRadius: '38px',
  ':before': {
    position: 'absolute',
    content: "''",
    height: '12px',
    width: '12px',
    left: '1px',
    bottom: '1px',
    borderRadius: '50%',
  },
})

const LabelText = styled.span({
  color: style.colors.monochrome.black,
  fontSize: '14px',
  lineHeight: '130%'
});


const SwitchOption = ({ facet, onFilterValuesUpdated }: PropType) => {
  const value = facet.values[0];

  const toggleSelected = () => {
    value.selected = !value.selected;
    onFilterValuesUpdated(facet.values, value.ticket);
  }

  const TRANSITION_DURATION = '.4s';
  return (
    <ToggleLabel
      css={{
        transitionDuration: TRANSITION_DURATION,
        
      }}
    >
      <LabelText>{value.displayName}</LabelText>
      <ToggleInput
        type="checkbox"
        checked={value.selected}
        onChange={toggleSelected}
      />
      <ToggleSwitch
        css={{
          border: {
            xy: {
              color: value.selected ? style.colors.brandColors.green : style.colors.monochrome.black,
            },
          },
          transitionDuration: TRANSITION_DURATION,
          backgroundColor: value.selected ? style.colors.brandColors.green : style.colors.monochrome.white,
          ':before': {
            backgroundColor: value.selected ? style.colors.monochrome.white : style.colors.monochrome.black,
            transitionDuration: TRANSITION_DURATION,
            transform: value.selected ? 'translateX(12px)' : undefined,
          },
        }}
      ></ToggleSwitch>
    </ToggleLabel>
  );
};

export default SwitchOption;
